<template>
  <v-card>
    <v-toolbar dense dark color="primary">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-layout row wrap>
        <v-form ref="form" v-model="isValidForm">
          <div>
            <slot />
          </div>
        </v-form>
        <v-alert outline class="mx-0 mt-3" type="warning" :value="isStateNext">
          <div class="primary--text">
            Cofactors without a default value were found. The current strategy requires default values to be set.
            Without a default value, the system may not be able to calculate guideline values.
            See the alerts at the top of this page to determine which cofactors don't have a default value.
          </div>
        </v-alert>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="success" @click="$emit('save')" :disabled="!enableSubmitStatus">
        <v-icon class="mr-1" v-html="isStateNext ? 'navigate_next' : 'done'" />
        {{proceedButtonText}}
      </v-btn>
      <v-btn @click="$emit('cancel')">{{$t('Button.Cancel')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      proceedButtonText: {
        type: String,
        default: 'Save',
      },
      enableSubmit: {
        type: Boolean,
        default: null,
      },
    },
    data() {
      return {
        isValidForm: true,
      }
    },
    computed: {
      isStateNext() {
        return this.proceedButtonText != 'Save'
      },
      enableSubmitStatus() {
        return this.enableSubmit != null ?
          this.enableSubmit :
          this.isValidForm
      },
    },
  }
</script>

<style scoped lang="stylus">
  form {
    width: 100%;
  }
</style>